module.exports = __webpack_public_path__ + "img/17.029bba09.jpg";